import React from 'react';
import { Upload } from 'lucide-react';
import './ImagingHeader.css';

// ImagingEmptyState renders the "no images yet" placeholder card shown
// when an imaging page has nothing to list. The icon and overall layout
// are fixed; everything else (copy + the call-to-action button) is
// driven by props so the upload page can wire it to its file picker and
// the images page can wire it to client-side navigation.
function ImagingEmptyState({
    title = 'No images yet',
    description = 'Get started by uploading your first image to begin organizing and sharing your collection.',
    actionLabel = 'Upload Images',
    onAction,
    actionDisabled = false,
    Icon = Upload,
    ActionIcon = Upload,
}) {
    return (
        <div className="review-card">
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '1rem',
                    textAlign: 'center',
                    padding: '2.5rem 2rem',
                }}
            >
                <div
                    style={{
                        borderRadius: '9999px',
                        backgroundColor: '#e5e7eb',
                        padding: '1.5rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Icon size={48} strokeWidth={2} color="#6b7280" />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', maxWidth: '28rem' }}>
                    <h2 style={{ fontSize: '1.5rem', fontWeight: 600, lineHeight: 1.25, margin: 0 }}>
                        {title}
                    </h2>
                    <p style={{ color: '#6b7280', margin: 0 }}>
                        {description}
                    </p>
                </div>
                {onAction && (
                    <button
                        type="button"
                        className="imaging-action-button primary"
                        onClick={onAction}
                        disabled={actionDisabled}
                        style={{ marginTop: '0.5rem' }}
                    >
                        <ActionIcon size={20} strokeWidth={2} />
                        {actionLabel}
                    </button>
                )}
            </div>
        </div>
    );
}

export default ImagingEmptyState;
